import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import throttle from 'lodash/throttle';
import cloneDeep from 'lodash/cloneDeep';
import Ad from '../../../components/ad/ad';
import adsConfig from '../../../../server/config/ads';
import { buildPostAdModel } from '../../../../utils/ad_util';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
// import Post from '../../../components/post/post';
import PostsContainer from '../../../components/post/container';
import RevContent from '../../../components/revcontent/revcontent';
import VideoModule from '../../../components/video_module/video_module';
import matchMediaDesktop from '../../../../utils/client_util';
import { loadAllThirdPartyJs } from '../../../../client/utils/third_party_js_util';

// eslint-disable-next-line react/prefer-stateless-function
class News extends Component {
  constructor() {
    super();

    this.setScrollEvents = this.setScrollEvents.bind(this);
    this.isDesktop = false;
  }

  componentDidMount() {
    this.window = window;
    this.activePost = null;
    this.isDesktop = matchMediaDesktop();
    this.trackedPosts = [];
    window.addEventListener('scroll', throttle(this.setScrollEvents, 100));
  }

  componentDidUpdate() {
    this.posts = this.getPostElements();
  }

  componentWillUnmount() {
    this.window.removeEventListener('scroll', this.setScrollEvents);
  }

  getPostElements() {
    return document.querySelectorAll('.post__body');
  }

  setScrollEvents() {
    const { scrollY, innerHeight } = this.window;
    this.setInviewPost(scrollY, innerHeight);
  }

  setInviewPost(windowPosition, screenHeight) {
    if (!this.posts || !this.posts.length) {
      return false;
    }

    // Set url to /news if at top of screen.
    if (windowPosition === 0) {
      window.history.replaceState({}, '', '/news');
      this.activePost = null;
      return false;
    }

    const triggerPoint = windowPosition + screenHeight / 2;
    for (let i = 1; i <= this.posts.length; i += 1) {
      const post = this.posts[i - 1];
      const sectionTopPosition = post.offsetTop;
      const sectionBottomPosition = sectionTopPosition + post.clientHeight;
      const { id, slug } = post.dataset;
      const postId = parseFloat(id);

      if (
        this.activePost !== postId &&
        sectionTopPosition <= triggerPoint &&
        sectionBottomPosition > triggerPoint
      ) {
        this.activePost = postId;
        this.setActiveSocial(post);

        window.history.replaceState({}, '', `/${postId}/${slug}`);

        if (this.trackedPosts.indexOf(this.activePost) === -1) {
          this.trackedPosts.push(this.activePost);
          this.refreshThirdPartyTrackers(post, i);
        }
      }
    }
    return false;
  }

  setActiveSocial(post) {
    const activeClass = 'social--active';
    const activeSocial = document.querySelector(`.${activeClass}`);

    if (activeSocial) {
      activeSocial.classList.remove(activeClass);
    }

    const activePost = post || document.querySelector('.post__wrapper');
    if (activePost) {
      activePost.querySelector('.social').classList.add(activeClass);
    }
  }

  refreshThirdPartyTrackers(postData, pageNumber) {
    const { config } = this.props;
    const currentActivePostState = {
      context: {
        site: get(config, 'site'),
        type: 'post',
        postData
      },
      config
    };
    loadAllThirdPartyJs(currentActivePostState, pageNumber);
  }

  generateAdData(categoryData) {
    const { config } = this.props;
    const site = get(config, 'site') || 'fastcompany';
    const adData = buildPostAdModel(
      adsConfig,
      site,
      categoryData,
      'categoryPage'
    );

    return extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') || {} },
      { definitions: get(adData, 'config.definitions') || {} },
      { model: adData.model || {} }
    );
  }

  renderNewsSection(numPosts, first = false) {
    let posts = this.posts;
    let slice = numPosts;
    const totalPosts = posts.length;

    if (!totalPosts) return null;

    if (totalPosts <= numPosts) {
      slice = totalPosts;
    }

    posts = this.posts.splice(0, slice);

    return (
      <PostsContainer
        {...this.props}
        posts={posts}
        combinedAdModel={this.combinedAdModel}
        isDesktop={this.isDesktop}
        isFirst={first}
        pageNum={1}
        videoAdData={get(this.props.categoryPage, 'ads.model', {})}
      />
    );
  }

  render() {
    this.posts = cloneDeep(get(this.props.categoryAllFeed, 'posts', []));

    if (
      this.props.categoryPage.error ||
      this.props.categoryFeaturedFeed.error
    ) {
      return (
        <section className="category-page">
          <article className="category-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.categoryPage.isLoading) {
      return (
        <section className="category-page">
          <article className="category-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { config } = this.props;
    const adData = get(this.props, 'categoryPage.ads');
    this.combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const currentSite = get(config, 'site');

    return (
      <section className="category-page category-page--news">
        {this.renderNewsSection(3, true)}

        <RevContent
          initialPageLoad={get(this.props, 'config.initialPageLoad')}
          site={currentSite}
        />

        <div className="category-page__ff-ad-container">
          <Ad {...this.combinedAdModel} name="flexiblebillboard_2" />
          <Ad {...this.combinedAdModel} name="mobilerectangle_1" />
        </div>

        {this.renderNewsSection(5)}

        <VideoModule
          data={this.props.categoryVideo}
          playerid="HliaKwd3"
          stories={this.props.categoryVideo.playlist}
          currentSite={currentSite}
        />

        <div className="category-page__ff-ad-container">
          <Ad {...this.combinedAdModel} name="flexiblebillboard_3" />
          <Ad {...this.combinedAdModel} name="mobilerectangle_2" />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: get(state, 'categoryFeaturedFeed.source') || '',
      featured: get(state, 'categoryFeaturedFeed.featured') || [],
      top: get(state, 'categoryFeaturedFeed.top') || [],
      category: get(state, 'categoryFeaturedFeed.category') || {},
      error: get(state, 'categoryFeaturedFeed.error') || false
    },
    categoryVideo: {
      playlist: get(state, 'categoryVideo.data.playlist') || [],
      title: get(state, 'categoryVideo.data.title') || '',
      feedid: get(state, 'categoryVideo.data.feedid') || ''
    },
    categoryPage: get(state, 'categoryPage') || {},
    categoryAllFeed: {
      allRendered: get(state, 'categoryAllFeed.allRendered') || false,
      posts: get(state, 'categoryAllFeed.data') || []
    }
  };
}

News.propTypes = {
  config: PropTypes.shape({}).isRequired,
  categoryPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  categoryFeaturedFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    category: PropTypes.object,
    error: PropTypes.bool
  }).isRequired,
  categoryVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  categoryAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(News));



// WEBPACK FOOTER //
// ./src/views/containers/pages/category_page/news_page.js